import { render, staticRenderFns } from "./ViewReportPage.vue?vue&type=template&id=7dc4f349"
import script from "./ViewReportPage.ts?vue&type=script&lang=ts&external"
export * from "./ViewReportPage.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc4f349')) {
      api.createRecord('7dc4f349', component.options)
    } else {
      api.reload('7dc4f349', component.options)
    }
    module.hot.accept("./ViewReportPage.vue?vue&type=template&id=7dc4f349", function () {
      api.rerender('7dc4f349', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/report_management/viewReportPage/ViewReportPage.vue"
export default component.exports